(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  function updateHeaderCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        const count = cart.items.length;
        const cartIconBubble = document.getElementById('cart-icon-bubble');

        if (!cartIconBubble) return;

        let bubble = cartIconBubble.querySelector('[data-cart-count-bubble]');

        if (count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.setAttribute('data-cart-count-bubble', '');

            bubble.innerHTML = `
              <span aria-hidden="true" data-cart-count>${count < 100 ? count : '99+'}</span>
              <span class="visually-hidden">${count} products in cart</span>
            `;

            cartIconBubble.appendChild(bubble);
          } else {
            const countEl = bubble.querySelector('[data-cart-count]');
            const hiddenEl = bubble.querySelector('.visually-hidden');

            if (countEl) countEl.textContent = count < 100 ? count : '99+';
            if (hiddenEl) hiddenEl.textContent = `${count} products in cart`;
          }
        } else if (bubble) {
          bubble.remove();
        }
      })
      .catch((error) => {
        console.error('Cart count update failed:', error);
      });
  }

  function runCartCountRefreshBurst() {
    updateHeaderCartCount();
    setTimeout(updateHeaderCartCount, 300);
    setTimeout(updateHeaderCartCount, 700);
    setTimeout(updateHeaderCartCount, 1200);
    setTimeout(updateHeaderCartCount, 2000);
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    runCartCountRefreshBurst();

    document.body.addEventListener('click', function(e) {
      const addToCartTrigger = e.target.closest(
        'button[name="add"], .product-form__submit, [type="submit"][name="add"], .quick-add__submit'
      );

      if (addToCartTrigger) {
        runCartCountRefreshBurst();
      }
    }, true);

    document.body.addEventListener('submit', function(e) {
      const addToCartForm = e.target.closest('form[action*="/cart/add"]');

      if (addToCartForm) {
        runCartCountRefreshBurst();
      }
    }, true);

    const originalFetch = window.fetch;
    window.fetch = function() {
      return originalFetch.apply(this, arguments).then((response) => {
        try {
          const req = arguments[0];
          const url = typeof req === 'string' ? req : req && req.url ? req.url : '';

          if (
            url.includes('/cart/add') ||
            url.includes('/cart/add.js') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear')
          ) {
            runCartCountRefreshBurst();
          }
        } catch (e) {
          console.error(e);
        }

        return response;
      });
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
      this._cartUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function() {
      this.addEventListener('load', function() {
        if (
          this._cartUrl &&
          (
            this._cartUrl.includes('/cart/add') ||
            this._cartUrl.includes('/cart/add.js') ||
            this._cartUrl.includes('/cart/change') ||
            this._cartUrl.includes('/cart/update') ||
            this._cartUrl.includes('/cart/clear')
          )
        ) {
          runCartCountRefreshBurst();
        }
      });

      return originalSend.apply(this, arguments);
    };

    document.addEventListener('cart:refresh', runCartCountRefreshBurst);
    document.addEventListener('cart:updated', runCartCountRefreshBurst);
  });

  } catch(e) { console.error(e); }
})();
})();
